export interface ExternalSearchCreds {
  application: string;
  indexName: string;
  token: string;
  expires: number;
}

interface ExternalSearchCacheInterface {
  creds: {
    [key: string]: ExternalSearchCreds;
  };
  /**
   * In-flight token requests, keyed by tenant.
   *
   * `creds` is only written once a request resolves, so without this every concurrent
   * caller sees an empty cache and starts its own `/search`. One My Orders load issued six
   * token requests - four from `use-smart-navigation-data` and two from `Listy`. Callers
   * now share the pending promise.
   */
  inFlight: {
    [key: string]: Promise<ExternalSearchCreds | undefined> | undefined;
  };
  loading: boolean;
}

export const ExternalSearchCache: ExternalSearchCacheInterface = {
  creds: {},
  inFlight: {},
  loading: false
};
